export default "__VITE_ASSET__GnJrCUMd__"